import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-5a047988")
const _hoisted_1 = { class: "card flex flex-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "stats"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", null, "My dashboard", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "break" }, null, -1)
const _hoisted_5 = { class: "m-[24px] flex flex-1 flex-col justify-center" }
const _hoisted_6 = {
  key: 0,
  class: "mt-5 w-full text-center"
}
const _hoisted_7 = { class: "mt-[40px] flex w-full items-center self-center" }
const _hoisted_8 = { class: "flex flex-1 items-center justify-center" }
const _hoisted_9 = { class: "flex py-5" }
const _hoisted_10 = { class: "mr-4 mt-3" }
const _hoisted_11 = { class: "title" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", null, "Total value", -1)
const _hoisted_13 = { class: "flex flex-1 items-center justify-center" }
const _hoisted_14 = { class: "flex py-5" }
const _hoisted_15 = { class: "mr-4 mt-3" }
const _hoisted_16 = { class: "title claim-amount" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", null, "Total Rewards", -1)
const _hoisted_18 = { class: "mx-10 w-full max-w-md self-center" }
const _hoisted_19 = { class: "progress-bar mt-[32px] h-[2px] rounded-[24px]" }
const _hoisted_20 = { class: "progress-perc text-right" }
const _hoisted_21 = { class: "pool-invest flex-1 text-center" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Unstake & Withdraw your position ")
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "w-full text-center" }, "Unstake & Withdraw", -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" You can claim in any time ")
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "w-full text-center" }, "Claim reward", -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PoolUserStats = _resolveComponent("PoolUserStats")!
  const _component_WalletNewIcon = _resolveComponent("WalletNewIcon")!
  const _component_DollarCoinsStackedIcon = _resolveComponent("DollarCoinsStackedIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ArrowRightIcon = _resolveComponent("ArrowRightIcon")!
  const _component_StakeModal = _resolveComponent("StakeModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["container mx-auto", { ' mb-[20px]': _ctx.isMobile, 'mb-[95px]': _ctx.isDesktop }]),
      id: "dashboard"
    }, [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.isDesktop)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _hoisted_4,
              _createVNode(_component_PoolUserStats, {
                pool: _ctx.pool,
                xpolarToClaim: _ctx.xpolarToClaim,
                dailyAPR: _ctx.dailyAPR,
                stakedBalance: _ctx.stakedBalance
              }, null, 8, ["pool", "xpolarToClaim", "dailyAPR", "stakedBalance"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Loading..."))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_WalletNewIcon)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.fiatValue), 1),
                        _hoisted_12
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_DollarCoinsStackedIcon)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.rewardFiat), 1),
                        _hoisted_17
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", {
                      class: "progress absolute bottom-0 left-0 h-[2px] w-0 rounded-[24px] bg-styling-teal opacity-80 transition duration-300 ease-linear dark:bg-styling-teal",
                      style: _normalizeStyle({ width: `${(_ctx.stakedPerc * 100).toFixed(0)}%` })
                    }, null, 4)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createTextVNode(_toDisplayString(_ctx.stakedPerc * 100) + "% of your LP tokens staked ", 1),
                    (_ctx.stakedPerc < 1)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "stake-btn ml-2 inline",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleStakeModal()))
                        }, " Stake the rest "))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["my-panel flex flex-1 py-8 pl-[24px]", { 'flex-col items-center': _ctx.isMobile }])
                }, [
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createVNode(_component_router_link, {
                      class: "withdraw-btn flex items-center",
                      to: '/pool/' + _ctx.pool?.id + '/withdraw'
                    }, {
                      default: _withCtx(() => [
                        _hoisted_23
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["pool-invest flex-1 text-center", { 'mt-8': _ctx.isMobile }])
                  }, [
                    _hoisted_24,
                    _createElementVNode("button", {
                      class: "claim-btn block flex w-full items-center",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.claimXpolar(_ctx.pool.address)))
                    }, [
                      _hoisted_25,
                      _createVNode(_component_ArrowRightIcon, { class: "ml-3 flex-none" })
                    ])
                  ], 2)
                ], 2)
              ], 64))
        ])
      ])
    ], 2),
    _createVNode(_component_StakeModal, {
      depositBol: true,
      isVisible: _ctx.isStakeModalVisible,
      token: ``,
      balance: _ctx.balanceFor(_ctx.pool.address),
      address: _ctx.pool.address,
      onClose: _ctx.toggleStakeModal
    }, null, 8, ["isVisible", "balance", "address", "onClose"])
  ], 64))
}